import api, { ResponseCallback } from '../services/api.service'

export interface HeartbeatData {
  status: string
  code: number
}

const routes = {
  heartbeat: '/heartbeat'
}

export default {
  heartbeat (callback: ResponseCallback<HeartbeatData>) {
    api.get(routes.heartbeat, {}, callback, 'backend', true)
  }
}
